import { comics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function HotRecommend() {
  const hotComics = comics.filter((c) => c.rating >= 9.4).slice(0, 8);

  return (
    <section className="py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              <i className="ri-fire-line text-accent-500 mr-2"></i>
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">精选高分漫画，不容错过</p>
          </div>
          <a href="/category/shaonian" className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1">
            查看更多
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-4 md:gap-5">
          {hotComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}